import { createContext } from 'react';

import { configuration } from '../store';
export const ReturnUrlContext = createContext(configuration.defaultReturnUrl);
